import {initLookupComponent} from "../_components/lookup";

document.addEventListener('DOMContentLoaded', () => {
    const fullReportDataElement = document.getElementById("lookup-sections");

    if (fullReportDataElement && fullReportDataElement.dataset.hasOwnProperty("fullReportData")) {
        try {
            const fullReportData = JSON.parse(fullReportDataElement.dataset.fullReportData);
            initLookupComponent(fullReportData);

        } catch (e) {
            console.error("Something went wrong...:", e);
        }
    }

    document.querySelectorAll(".current-manufacturer-logo").forEach((img) => {
        const prepareLogo = () => {
            if (img.naturalWidth && img.naturalHeight && (img.naturalWidth / img.naturalHeight) > 1.7) {
                img.classList.add("current-manufacturer-logo--wide");
            }

            trimSvgLogoWhitespace(img);
        };

        if (img.complete && img.naturalWidth) {
            prepareLogo();
        } else {
            img.addEventListener("load", prepareLogo, {once: true});
        }
    });
})

/**
 * Tightens SVG viewBox to opaque pixels so padded canvases match already-cropped logos.
 */
async function trimSvgLogoWhitespace(img) {
    const src = img.currentSrc || img.src;
    if (!/\.svg(\?|#|$)/i.test(src)) {
        return;
    }

    try {
        if (!img.complete || !img.naturalWidth) {
            await img.decode();
        }

        const bounds = getOpaqueBounds(img);
        if (!bounds || (bounds.width > 0.97 && bounds.height > 0.97)) {
            return;
        }

        const svgText = await fetch(src).then((response) => response.text());
        const doc = new DOMParser().parseFromString(svgText, "image/svg+xml");
        const svg = doc.documentElement;
        if (!svg || svg.namespaceURI !== "http://www.w3.org/2000/svg") {
            return;
        }

        const viewBox = parseSvgViewBox(svg, img.naturalWidth, img.naturalHeight);
        const pad = 0.015;
        const left = Math.max(0, bounds.left - pad);
        const top = Math.max(0, bounds.top - pad);
        const right = Math.min(1, bounds.left + bounds.width + pad);
        const bottom = Math.min(1, bounds.top + bounds.height + pad);

        svg.setAttribute("viewBox", [
            viewBox.x + left * viewBox.w,
            viewBox.y + top * viewBox.h,
            (right - left) * viewBox.w,
            (bottom - top) * viewBox.h,
        ].join(" "));
        svg.removeAttribute("width");
        svg.removeAttribute("height");

        img.src = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(new XMLSerializer().serializeToString(svg))}`;
    } catch {
        // Keep the original logo if canvas/SVG parsing is unavailable.
    }
}

function parseSvgViewBox(svg, fallbackWidth, fallbackHeight) {
    const raw = svg.getAttribute("viewBox");
    if (raw) {
        const parts = raw.trim().replace(/,/g, " ").split(/\s+/).map(Number);
        if (parts.length === 4 && parts.every(Number.isFinite)) {
            return {x: parts[0], y: parts[1], w: parts[2], h: parts[3]};
        }
    }

    return {
        x: 0,
        y: 0,
        w: parseFloat(svg.getAttribute("width")) || fallbackWidth || 1,
        h: parseFloat(svg.getAttribute("height")) || fallbackHeight || 1,
    };
}

function getOpaqueBounds(img) {
    const naturalWidth = img.naturalWidth;
    const naturalHeight = img.naturalHeight;
    if (!naturalWidth || !naturalHeight) {
        return null;
    }

    const maxSide = 256;
    const scale = Math.min(1, maxSide / Math.max(naturalWidth, naturalHeight));
    const width = Math.max(1, Math.round(naturalWidth * scale));
    const height = Math.max(1, Math.round(naturalHeight * scale));
    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext("2d", {willReadFrequently: true});
    if (!ctx) {
        return null;
    }

    ctx.drawImage(img, 0, 0, width, height);

    let data;
    try {
        data = ctx.getImageData(0, 0, width, height).data;
    } catch {
        return null;
    }

    let minX = width;
    let minY = height;
    let maxX = -1;
    let maxY = -1;

    for (let i = 0; i < data.length; i += 4) {
        if (data[i + 3] <= 8) {
            continue;
        }

        const pixel = i / 4;
        const x = pixel % width;
        const y = (pixel / width) | 0;
        if (x < minX) minX = x;
        if (x > maxX) maxX = x;
        if (y < minY) minY = y;
        if (y > maxY) maxY = y;
    }

    if (maxX < 0) {
        return null;
    }

    return {
        left: minX / width,
        top: minY / height,
        width: (maxX - minX + 1) / width,
        height: (maxY - minY + 1) / height,
    };
}
